import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-chip',
  imports: [],
  templateUrl: './chip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chip.component.css',
})
export class ChipComponent {
  /**
   * Visual variant of the chip
   */
  variant = input<'default' | 'highlighted'>('default');

  /**
   * Color theme of the chip
   */
  color = input<'primary' | 'accent' | 'success' | 'warning' | 'danger'>('primary');
}
